export default __webpack_public_path__ + "content/925b340f49e65e8bab10da01bbcf9e30.woff";